import type { ISms } from "@bbj-types/message";
import { Popover, type PopoverProps, Typography } from "@mui/material";

interface ISmsInfoPopover extends Omit<PopoverProps, "open" | "anchorOrigin" | "transformOrigin"> {
  info: Pick<ISms, "providerId" | "errorCode">;
}

export const SmsInfoPopover = ({ info, anchorEl, ...props }: ISmsInfoPopover) => {
  return (
    <Popover
      open={Boolean(anchorEl)}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      anchorEl={anchorEl}
      {...props}
    >
      <Typography
        sx={{
          p: 1,
        }}
      >
        ProviderID: <Typography variant="body1SemiBold">{info.providerId}</Typography>
      </Typography>
      <Typography
        sx={{
          p: 1,
        }}
      >
        ErrorCode: <Typography variant="body1SemiBold">{info.errorCode}</Typography>
      </Typography>
    </Popover>
  );
};
